import { render, staticRenderFns } from "./aiMailView.vue?vue&type=template&id=54465f35"
import script from "./aiMailView.vue?vue&type=script&lang=js"
export * from "./aiMailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports